import styled from 'styled-components';
import COLORS from '../../style/universal.color';
import { Img } from '../Image/image.style';
import { splitSquadCoreStyle } from '../Team/team.style';

const { mlbGrey1, mlbGrey3, mlbGrey4, mlbGrey5, mlbGrey6, mlbGrey7 } = COLORS;

interface InningHeadProps {
  dark: boolean;
}

interface InningCellProps {
  dark: boolean;
  lost?: boolean;
  full?: boolean;
  team?: boolean;
  complete?: boolean;
  inningsType: boolean;
  paddingTop?: string;
  runs?: boolean;
}

interface WrapperProps {
  maxWidth: string;
  scheduledInnings: number;
  maxInningsDisplayed: number;
  collapsed?: boolean;
  logoHeight: string;
  logoOffset: string;
}

const retrieveInningColor = (dark: boolean, inningsType: boolean, team?: boolean): string => {
  if (inningsType && !team) {
    return dark ? mlbGrey3 : mlbGrey5;
  } else {
    return dark ? mlbGrey1 : mlbGrey7;
  }
};

export const StyledHeadCell = styled.div<InningHeadProps>`
  color: ${({ dark }) => (dark ? mlbGrey4 : mlbGrey6)};
  font-weight: 700;
  display: inline-block;
  font-size: 11px;
`;

export const StyledInningCell = styled.div<InningCellProps>`
  display: inline-block;
  padding-top: ${({ paddingTop }) => paddingTop};
  color: ${({ dark, inningsType, team }) => retrieveInningColor(dark, inningsType, team)};
  font-weight: ${({ team, runs }) => (runs || team ? 'bold' : '600')};
  font-size: 15px;
  min-height: 14px;
`;

export const SplitSquadWrapper = styled.div.attrs<{ 'data-mlb-test'?: string }>({
  'data-mlb-test': 'splitSquadLabel',
})`
  ${splitSquadCoreStyle}
  position: absolute;
  bottom: 6px;
  left: -8px;
`;

// Contains code for hiding the scrollbar
export const LineScoreWrapper = styled.div<WrapperProps>`
  max-width: ${({ maxWidth }) => maxWidth};
  height: 68px;

  > div:first-child {
    > div {
      overflow: auto;
      table {
        overflow: visible;
        th {
          overflow: visible;
          ${Img} {
            margin-top: ${({ logoOffset }) => logoOffset};
            height: ${({ logoHeight }) => logoHeight};
            width: ${({ logoHeight }) => logoHeight};
          }
        }

        ${({ scheduledInnings, maxInningsDisplayed, collapsed }) =>
          !collapsed ? `width: calc(100% / ${scheduledInnings} * ${maxInningsDisplayed});` : ''}
      }
    }
  }

  display: inline-block;

  > div:last-child {
    margin-left: 3px;
  }
  div {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background: transparent; /* Chrome/Safari/Webkit */
    }
  }
`;
